import React from 'react';
import { loadingToSuccess, loadingToError, showSuccessToast, showErrorToast } from '@components/Notify/Toast';
import { createAsyncOperationTracker } from '../createAsyncOperationTracker';

export const exportTracker = createAsyncOperationTracker({
  prefix: 'export',
  loadingMessage: (
    <div className="d-flex flex-column text-start">
      <span className="fw-bold">Preparing your file...</span>
      <small className="text-muted">It will download automatically when ready.</small>
    </div>
  ),
  pendingTtl: 900000,
  completedTtl: 180000,
  toastDuration: 120000,
  getPayload: (response) => response?.data?.data ?? response?.data ?? response ?? null,
  getOperationId: (payload) => payload?.operation_id
});

export const handleQueuedExportResponse = exportTracker.handleQueuedResponse;
export const completeExportOperation = exportTracker.completeOperation;
export const getExportToastId = exportTracker.getToastId;

export const startFileDownload = (url) => {
  if (!url) return;
  const link = document.createElement('a');
  link.href = url;
  link.rel = 'noopener';
  document.body.append(link);
  link.click();
  link.remove();
};

const readyMessage = (data) => (
  <span>
    Export ready{data?.file_name ? `: ${data.file_name}` : ''}.{' '}
    <a href={data?.download_url} target="_blank" rel="noreferrer">
      Download
    </a>
  </span>
);

const handleExportStatus = (data, { dispatch } = {}) => {
  const operationId = data?.operation_id;
  const context = completeExportOperation(operationId, data);
  const toastId = operationId ? getExportToastId(operationId) : null;

  if (data?.status === 'failed') {
    const message = data?.error || 'Export failed.';
    if (toastId) loadingToError(toastId, message);
    else showErrorToast(message);
    return;
  }

  const options = { duration: 15000 };
  if (toastId) loadingToSuccess(toastId, readyMessage(data), options);
  else showSuccessToast(readyMessage(data), options);

  startFileDownload(data?.download_url);
  context?.onComplete?.(data, { dispatch });
};

export const exportHandlers = {
  'export.status': handleExportStatus
};
